module.exports = __webpack_public_path__ + "static/media/news_icon_svg.4665c2e6.svg";